import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Row, Col, Typography, Card, Skeleton, Image, Space, Tag, Pagination, Empty } from 'antd'
import { menuApplications, unmountMenuApplications, listApplications, unmountListApplications } from '../../../../redux/actions/applications/applicationsAction'
import { SafetyOutlined, EnvironmentOutlined } from '@ant-design/icons'
import EmptyLogo from '../../../../assets/img/EmptyLogo.png';
import MenuApplications from '../Menu';

const { Text } = Typography;

export class index extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      params: {
        page: 1,
        perpage: 10,
        // phaseId: 11,
        phaseId: 5,
        jobStatus: 'ACTIVE'
      },
      activeKey: "Shortlisted",
      visible: false,
      isReschedule: false,
      submitLoading: false,
    }
  }
  
  componentDidMount() {
    const { params } = this.state
    const { actionMenuApplications, actionListApplications } = this.props

    return (actionMenuApplications(), actionListApplications(params))
  }

  handlePagination = (pageNumber) => {
    const { params: { perpage, phaseId, jobStatus } } = this.state
    const params = {
      page: pageNumber,
      perpage: perpage,
      phaseId: phaseId,
      jobStatus: jobStatus
    }
    this.setState({ params })
    window.scrollTo(0, 0);
    const { actionListApplications } = this.props
    return actionListApplications(params)
  }

  render() {
    const { activeKey } = this.state
    const { t, getMenuApplications, getListApplications } = this.props

    if(process.env.REACT_APP_ENV === "production"){
      ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Jobshub - Applications - Shortlisted');
    }

    const initialProps = {
      activeKey: activeKey
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Jobshub - Applications - Shortlisted</title>
        </Helmet>
        <Row className="padding-16">
          <Col className="width-100" md={{ span: 20, offset: 2 }}>
            <Row className="mb-32">
              <Col>
                <Text className="dark-color fs-20">{t('application.applications')}</Text>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col xs={24} lg={4}>
                {
                  getMenuApplications.loading ?
                    <Skeleton active />
                  :
                    <MenuApplications {...this.props} {...initialProps} />
                }
              </Col>
              <Col xs={24} lg={20}>
                <Row className="width-100 mb-8" gutter={8}>
                  <Col span={24}>
                    {
                      getListApplications.data ?
                        <Text className="dark-color fs-13">{`${t('application.shortlisted.showing')} ${getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : (getListApplications?.meta?.page*getListApplications?.meta?.perpage)-(getListApplications?.meta?.perpage-1)}-${getListApplications?.meta?.page === getListApplications?.meta?.pages || getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : getListApplications?.meta?.page*getListApplications?.meta?.perpage} of ${getListApplications?.meta?.total} ${t('application.shortlisted.job')}`}</Text>
                      :
                        <Skeleton.Input active />
                    }
                  </Col>
                </Row>
                <Row className="mb-16">
                  <Col span={24}>
                    {
                      getListApplications.loading ?
                        <Card className="border-radius-3 box-shadow mb-6">
                          <Skeleton active avatar />
                        </Card>
                      :
                        getListApplications?.data?.length > 0 ?
                          getListApplications?.data?.map((item, i) => 
                            <Card key={i} className="border-radius-3 box-shadow mb-6">
                              <Row className="width-100" gutter={16} style={{ marginBottom: -10 }}>
                                <Col className="col-img-job" xs={24} sm={4} md={4}>
                                  {/* <Link to={`/candidate/company/${item.companyId}/${item.companyType}`}> */}
                                  <Link to={`/candidate/job/detail/${item.slug}`}>
                                    <Image
                                      src={item.companyLogoUrl ? item.companyLogoUrl : EmptyLogo}
                                      preview={false}
                                      width={'100%'}
                                      height={80}
                                      style={{ objectFit: 'contain' }}
                                    />
                                  </Link>
                                </Col>
                                <Col xs={24} sm={13} md={12}>
                                  <Space direction="vertical" size={0}>
                                    <Link to={`/candidate/job/detail/${item.slug}`}>
                                      <Text className="info-color fs-17">{item.title}</Text>
                                    </Link>
                                    <Text className="fs-13 dark-color">{item.companyName} {item.isVerified ? <SafetyOutlined className="primary-color" /> : null}</Text>
                                    <Text className="fs-13 dark-color"><EnvironmentOutlined /> {item.jobDestinationParentId ? `${item.jobDestinationName}, ${item.jobDestinationParentName}` : item.jobDestinationName}</Text>
                                  </Space>
                                </Col>
                                <Col xs={24} sm={7} md={8} className="application-date">
                                  <Space direction="vertical" size={8} className="application-date">
                                    <Text className="application-date fs-13 dark-color">{`${t('application.shortlisted.applied')} ${item.applyDate}`}</Text>
                                    <Tag className="application-date border-radius-3 fs-13" color={item.isOffered === 'Hiring' ? 'success' : 'error'}>{item.isOffered}</Tag>
                                  </Space>
                                </Col>
                              </Row>
                          </Card>
                      )
                        :
                          <Card className="border-radius-3 box-shadow mb-6">
                            <Empty />
                          </Card>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col className="text-align-center" span={24}>
                    <Pagination onChange={this.handlePagination} current={getListApplications?.meta?.page} pageSize={getListApplications?.meta?.perpage || 10} total={getListApplications?.meta?.total} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  componentWillUnmount(){
    const { unmountMenuApplications, unmountListApplications } = this.props
    return (unmountMenuApplications(), unmountListApplications())
  }
}

const mapStateToProps = (state) => ({
  getMenuApplications: state.menuApplicationsReducer,
  getListApplications: state.listApplicationsReducer
})

const mapDispatchToProps = {
  actionMenuApplications: menuApplications,
  unmountMenuApplications: unmountMenuApplications,
  actionListApplications: listApplications,
  unmountListApplications: unmountListApplications
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(index))